import React, { useState } from 'react';
import Sidebar from './Sidebar.js';
import AdminHeader from './Header.js';
import { Card, Row, Col, Container, Button } from 'react-bootstrap';
import Breadcrumb from './Breadcrumb.js';
import occupations from './data/occupations.js';
import { Modal } from 'react-bootstrap';
import { FiClipboard } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const MappingOccupationView = () => {

    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalTitle, setModalTitle] = useState('');

    return (
        <>
            <AdminHeader />
            <Container className="pt-2">
                <Row>
                    <Col xs={2} className="p-0">
                    </Col>
                    <Col xs={10} className="p-0">
                        <Breadcrumb />
                    </Col>
                </Row>
            </Container>
            <Container fluid>
                <Row>
                    <Col xs={3} className="p-0">
                        <Sidebar />
                    </Col>

                    <Col xs={9} className="p-4">
                        <Card>
                            <Card.Body>
                                <h1 className="mb-3">Occupation</h1>
                                <Row className="mb-4">
                                    <Col>
                                        {occupations.map((occupation, index) => (
                                            <Row>
                                                <Col md={12}>
                                                    <p className="form-control-plaintext">
                                                        {occupation.title} &nbsp;
                                                        {occupation.code}  &nbsp;
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            onClick={() => {
                                                                setModalTitle('Tasks - ' + occupation.title);
                                                                setModalContent(occupation.tasks || 'No tasks description available.');
                                                                setShowModal(true);
                                                            }}
                                                            title="View tasks"
                                                        >
                                                            <FiClipboard size={20} />
                                                        </Button>
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            onClick={() => {
                                                                setModalTitle('Included occupations - ' + occupation.title);
                                                                setModalContent(occupation.includedOccupations || 'No included occupations available.');
                                                                setShowModal(true);
                                                            }}
                                                            title="View Included occupations"
                                                        >
                                                            <FiClipboard size={20} />
                                                        </Button>
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            onClick={() => {
                                                                setModalTitle('Encluded occupations - ' + occupation.title);
                                                                setModalContent(occupation.excludedOccupations || 'No excluded occupations available.');
                                                                setShowModal(true);
                                                            }}
                                                            title="View excluded occupations"
                                                        >
                                                            <FiClipboard size={20} />
                                                        </Button>
                                                        <Button
                                                            variant="link"
                                                            className="p-0"
                                                            onClick={() => {
                                                                setModalTitle('Notes - ' + occupation.title);
                                                                setModalContent(occupation.notes || 'No notes available.');
                                                                setShowModal(true);
                                                            }}
                                                            title="View notes occupations"
                                                        >
                                                            <FiClipboard size={20} />
                                                        </Button>
                                                        <Button
                                                            variant="secondary"
                                                            onClick={() => navigate(`/mapping-occupation/${occupation.code}/suboccupation`)}
                                                            >
                                                                Sub Occupation
                                                        </Button>
                                                    </p>
                                                </Col>
                                            </Row>
                                        ))}
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-end gap-2 px-4">
                        <Button variant="secondary" onClick={() => navigate('/mapping-overview')}>
                            Back
                        </Button>
                    </Col>
                </Row>
            </Container>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle} {}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{modalContent}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                    Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default MappingOccupationView;
